import React from 'react'
import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { DemoMaterialRequest } from 'app/models/RequestFlow'
import styles from './homeDemoMaterialRequest.styles'

type Props = {
  request: Pick<DemoMaterialRequest, 'sale_order_id' | 'sale_order_error'>
}

const isPresent = (value?: string | null) =>
  typeof value === 'string' ? value.trim().length > 0 : !!value

const SalesOrderChip = ({ request }: Props) => {
  const { t } = useTranslation()
  const hasSaleOrderId = isPresent(request.sale_order_id)
  const hasError = !hasSaleOrderId && isPresent(request.sale_order_error)

  let valueText = ' --'
  if (hasSaleOrderId) {
    valueText = ` ${request.sale_order_id}`
  } else if (hasError) {
    valueText = ` ${t('demo_sales_order_failed')}`
  }

  return (
    <View style={styles.saleOrderChip}>
      <Text style={styles.saleOrderLabel}>{t('demo_sales_order_label')}</Text>
      <Text style={styles.saleOrderValue}>{valueText}</Text>
    </View>
  )
}

export default SalesOrderChip
